import { useEffect, useMemo } from "react";

import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/auth";
import { USER_ROLES } from "../../helpers/constants";

export const useHasRole = (requiredRoles) => {
    const { user } = useAuth();

    return useMemo(() => {
        if (!user || requiredRoles.length === 0) {
            return false;
        }

        return requiredRoles.some((role) => {
            return Boolean(user[role]);
        });
    }, [user, requiredRoles]);
};

export const useHasAllRoles = (requiredRoles) => {
    const { user } = useAuth();

    return useMemo(() => {
        if (!user || requiredRoles.length === 0) {
            return false;
        }

        return requiredRoles.every((role) => {
            return Boolean(user[role]);
        });
    }, [user, requiredRoles]);
};

export const useCurrentRoles = () => {
    const { user } = useAuth();

    return useMemo(() => {
        if (!user) {
            return [];
        }

        const roles = [];
        const roleKeys = Object.values(USER_ROLES);

        roleKeys.forEach((role) => {
            if (user[role]) {
                roles.push(role);
            }
        });

        return roles;
    }, [user]);
};

export const useAccessControl = (requiredRoles, options = {}) => {
    const { redirectPath = "/no-access" } = options;
    const hasAccess = useHasRole(requiredRoles);
    const navigate = useNavigate();

    useEffect(() => {
        if (!hasAccess) {
            navigate(redirectPath);
        }
    }, [hasAccess, navigate, redirectPath]);

    return { hasAccess };
};
